import BannerAdTracker from "../BannerAdTracker/BannerAdTracker";
import GoogleTagAdapter from "../GoogleTagAdapter/GoogleTagAdapter";
import AdvertisementCookie from "../AdvertisementCookie/AdvertisementCookie";

export default class GooglePublisherTag {
  static setTargeting(props) {
    GoogleTagAdapter.push(function () {
      GoogleTagAdapter.collapseEmptyDivs();
      GoogleTagAdapter.setTargeting("Site", "VIDIO");
      GoogleTagAdapter.setTargeting("Platform", props.current_device);
      GoogleTagAdapter.setTargeting("channel", props.channel);
      GoogleTagAdapter.setTargeting("vidio_user_id", props.vidio_user_id);
      GoogleTagAdapter.setTargeting("vidio_user", props.vidio_user);
      GoogleTagAdapter.setTargeting("vidio_id", props.vidio_id);
      GoogleTagAdapter.setTargeting("vidio_categories", props.vidio_category);
      GoogleTagAdapter.setTargeting("banner_embed", props.banner_embed);

      if (props.banner_embed === "true") {
        GoogleTagAdapter.setTargeting(
          "vidio_embed_site",
          GooglePublisherTag.embedSite()
        );
      }
    });
  }

  static shouldRefresh(element, desktop) {
    let bounding = element.getBoundingClientRect();
    let thresholdTop = 0;
    if (desktop) {
      thresholdTop =
        document.querySelector(".site-header").offsetHeight / 2 + 1;
    }

    if (
      document.visibilityState === "visible" &&
      document.fullscreenElement == null &&
      bounding.top >= thresholdTop
    ) {
      return true;
    } else {
      return false;
    }
  }

  static refreshAdSlot(slot, id, desktop = false) {
    setInterval(function () {
      var el = document.getElementById(id);
      if (GooglePublisherTag.shouldRefresh(el, desktop)) {
        GoogleTagAdapter.push(function () {
          GoogleTagAdapter.refresh([slot]);
        });
      }
    }, 60 * 1000);
  }

  static constructAdProps(adSlot, adUuid, event) {
    var props = {};
    props.ad_slot = adSlot;
    props.ad_uuid = adUuid;
    props.advertiser_id = event.advertiserId;
    props.campaign_id = event.campaignId;
    props.creative_id = event.creativeId;
    props.is_empty = event.isEmpty;
    props.line_item_id = event.lineItemId;
    props.size = event.size;
    props.source_agnostic_creative_id = event.sourceAgnosticCreativeId;
    props.source_agnostic_line_item_id = event.sourceAgnosticLineItemId;
    return props;
  }

  static setAdLeaderboard(ad_slot, ad_size) {
    GoogleTagAdapter.push(function () {
      var ad_name = "leaderboard";
      var parsed_ad_size = JSON.parse(ad_size);
      var ad_uuid = BannerAdTracker.uuid();

      GooglePublisherTag.adjustUILeaderboard();
      GooglePublisherTag.trackSlotRenderEnded(ad_name, ad_uuid);
      GooglePublisherTag.trackImpressionViewable(ad_name, ad_uuid);

      window.kmklabs.gpt.leaderboard = GoogleTagAdapter.defineSlot(
        ad_slot,
        parsed_ad_size,
        ad_name
      );
    });
  }

  static setAdNativeRelated(ad_slot, ad_size) {
    GoogleTagAdapter.push(function () {
      var ad_name = "native_related";
      var parsed_ad_size = JSON.parse(ad_size);
      var ad_uuid = BannerAdTracker.uuid();

      GooglePublisherTag.adjustUINativeRelated();
      GooglePublisherTag.trackSlotRenderEnded(ad_name, ad_uuid);
      GooglePublisherTag.trackImpressionViewable(ad_name, ad_uuid);

      GoogleTagAdapter.defineSlot(ad_slot, parsed_ad_size, ad_name);
    });
  }

  static setAdPause(ad_slot, ad_size) {
    GoogleTagAdapter.push(function () {
      var parsed_ad_size = JSON.parse(ad_size);

      GooglePublisherTag.trackSlotRenderEndedPause();
      GooglePublisherTag.trackImpressionViewablePause();

      window.kmklabs.gpt.pause_ads = GoogleTagAdapter.defineSlot(
        ad_slot,
        parsed_ad_size,
        "pause_ads"
      );
    });
  }

  static setAdOverlay(ad_slot, ad_size) {
    GoogleTagAdapter.push(function () {
      GooglePublisherTag.adjustUIOverlay();

      var parsed_ad_size = JSON.parse(ad_size);
      window.kmklabs.gpt.overlay_ad = GoogleTagAdapter.defineSlot(
        ad_slot,
        parsed_ad_size,
        "overlay_ad"
      );
    });
  }

  static setAdTopBanner(ad_slot, ad_size) {
    GoogleTagAdapter.push(function () {
      var ad_name = "top_banner";
      var parsed_ad_size = JSON.parse(ad_size);
      var ad_uuid = BannerAdTracker.uuid();

      GooglePublisherTag.adjustUITopBanner();
      GooglePublisherTag.trackSlotRenderEnded(ad_name, ad_uuid);
      GooglePublisherTag.trackImpressionViewable(ad_name, ad_uuid);

      window.kmklabs.gpt.top_banner = GoogleTagAdapter.defineSlot(
        ad_slot,
        parsed_ad_size,
        ad_name
      );
    });
  }

  static setAdMiddleBanner(ad_slot, ad_size) {
    GoogleTagAdapter.push(function () {
      var ad_name = "middle_banner";
      var parsed_ad_size = JSON.parse(ad_size);
      var ad_uuid = BannerAdTracker.uuid();

      GooglePublisherTag.adjustUIMiddleBanner();
      GooglePublisherTag.trackSlotRenderEnded(ad_name, ad_uuid);
      GooglePublisherTag.trackImpressionViewable(ad_name, ad_uuid);

      GoogleTagAdapter.defineSlot(ad_slot, parsed_ad_size, ad_name);
    });
  }

  static setAdBillboard(ad_slot, ad_size) {
    GoogleTagAdapter.push(function () {
      var ad_name = "billboard";
      var parsed_ad_size = JSON.parse(ad_size);
      var ad_uuid = BannerAdTracker.uuid();

      GooglePublisherTag.adjustUIBillboard();
      GooglePublisherTag.trackSlotRenderEnded(ad_name, ad_uuid);
      GooglePublisherTag.trackImpressionViewable(ad_name, ad_uuid);

      GoogleTagAdapter.defineSlot(ad_slot, parsed_ad_size, ad_name);
    });
  }

  static isEventSlotType(slotName, event) {
    try {
      return !event.isEmpty && event.slot.getSlotId().getDomId() == slotName;
    } catch {
      return false;
    }
  }

  static adjustUILeaderboard() {
    GoogleTagAdapter.addEventListener("slotRenderEnded", function (event) {
      if (GooglePublisherTag.isEventSlotType("leaderboard", event)) {
        document.querySelector("#leaderboard").style.paddingTop = "18px";
      }
    });
  }

  static adjustUINativeRelated() {
    GoogleTagAdapter.addEventListener("slotRenderEnded", function (event) {
      if (GooglePublisherTag.isEventSlotType("native_related", event)) {
        document
          .querySelector("#native_related_ad_container")
          .classList.remove("hidden");
      }
    });
  }

  static adjustUIOverlay() {
    GoogleTagAdapter.addEventListener("slotRenderEnded", function (event) {
      if (GooglePublisherTag.isEventSlotType("overlay_ad", event)) {
        const width = event.size[0];
        const height = event.size[1];
        window.player.ads().overlay().showOverlayAd(width, height);
      }
    });
  }

  static adjustUITopBanner() {
    GoogleTagAdapter.addEventListener("slotRenderEnded", function (event) {
      if (GooglePublisherTag.isEventSlotType("top_banner", event)) {
        document.querySelector("#top_banner").style.textAlign =
          "-webkit-center";
      }
    });
  }

  static adjustUIMiddleBanner() {
    GoogleTagAdapter.addEventListener("slotRenderEnded", function (event) {
      if (GooglePublisherTag.isEventSlotType("middle_banner", event)) {
        document
          .querySelector("#middle_banner")
          .setAttribute("style", "text-align: center; margin-top: 12px;");
      }
    });
  }

  static adjustUIBillboard() {
    GoogleTagAdapter.addEventListener("slotRenderEnded", function (event) {
      if (GooglePublisherTag.isEventSlotType("billboard", event)) {
        document.querySelector("#billboard_ad_container").style.display =
          "block";
        document.querySelector(
          ".mobile-billboard-ad__container"
        ).style.cssText = "position: fixed; top: 0;";
        GooglePublisherTag.adjustUIStickyHeader();
      }
    });
  }

  static adjustUIStickyHeader() {
    var wrapper = document.querySelector("#billboard_ad_container");
    document.querySelector(".l-mobile__header").style.marginTop =
      this.getOffsetHeight(wrapper) + "px";
  }

  static getOffsetHeight(element) {
    return element.offsetHeight;
  }

  static trackSlotRenderEnded(ad_name, ad_uuid) {
    GoogleTagAdapter.addEventListener("slotRenderEnded", function (event) {
      if (event.slot.getSlotId().getDomId() == ad_name) {
        if (event.isEmpty) {
          BannerAdTracker.sendAdEventEmpty(ad_name, ad_uuid);
        } else {
          var props = GooglePublisherTag.constructAdProps(
            ad_name,
            ad_uuid,
            event
          );
          BannerAdTracker.sendAdEventStart(props);
        }
      }
    });
  }

  static trackImpressionViewable(ad_name, ad_uuid) {
    GoogleTagAdapter.addEventListener("impressionViewable", function (event) {
      if (event.slot.getSlotId().getDomId() == ad_name) {
        BannerAdTracker.sendAdEventImpressionViewable(ad_name, ad_uuid);
      }
    });
  }

  static trackSlotRenderEndedPause() {
    GoogleTagAdapter.addEventListener("slotRenderEnded", function (event) {
      if (event.slot.getSlotId().getDomId() == "pause_ads") {
        var props = GooglePublisherTag.constructAdProps("pause_ads", "", event);
        if (event.isEmpty) {
          window.player.ads().pauseAdvertisement().sendEmptyEvent(props);
        } else {
          window.player.ads().pauseAdvertisement().sendStartEvent(props);
        }
      }
    });
  }

  static trackImpressionViewablePause() {
    GoogleTagAdapter.addEventListener("impressionViewable", function (event) {
      if (event.slot.getSlotId().getDomId() == "pause_ads") {
        window.player.ads().pauseAdvertisement().sendImpressionEvent({});
      }
    });
  }

  static enableLazyLoad() {
    var options = {
      fetchMarginPercent: 0,
      renderMarginPercent: 0,
      mobileScaling: 1,
    };

    GoogleTagAdapter.push(function () {
      GoogleTagAdapter.enableLazyLoad(options);
    });
  }

  static enableServices() {
    if (AdvertisementCookie.showBannerAd()) {
      GoogleTagAdapter.push(function () {
        window.googletag.enableServices();
      });
    }
  }

  static embedSite() {
    const hostname = this.referrer().match(
      /^(?:https?:\/\/)?(?:[^@\n]+@)?([^:\/\n]+)/im
    );
    if (hostname === null) {
      return "null";
    }
    return hostname[1];
  }

  static referrer() {
    return document.referrer;
  }
}
